import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { EmployeeFormComponent } from '../employee-form/employee-form.component';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { EmployeeState } from 'src/app/modules/store/employee/employee.reducer';
import * as EmployeeActions from './../../../store/employee/employee.actions';
import {IEmployee} from '@signal/asp-data-commons';
import {AddLeavesComponent} from '../add-leaves/add-leaves.component';
import { HolidayState } from 'src/app/modules/store/holiday/holiday.reducer';
import * as HolidayActions from '../../../store/holiday/holiday.actions';
import { TranslateService } from '@ngx-translate/core';
import { SubscriptionList } from '../../models/asp.types';
import { unsubscribeSubscriptions } from '../../services/util.service';


@Component({
  selector: 'app-employee-card',
  templateUrl: './employee-card.component.html',
  styleUrls: ['./employee-card.component.scss']
})
export class EmployeeCardComponent implements OnInit, OnDestroy {
  @Input() employee: IEmployee;
  public currentDate = new Date().toISOString();
  private subs: SubscriptionList = {};

  constructor(public readonly dialog: MatDialog,
              private translate : TranslateService,
              private readonly employeeStore: Store<EmployeeState>,
              private readonly holidayState: Store<HolidayState>) {

  }

  ngOnInit() {
  }

  updateEmployee() {
    this.currentDate = new Date().toISOString();
    this.employeeStore.dispatch(new EmployeeActions.LoadEmployee({ employeeId: this.employee.id }));
    const clHt = this.employee?.department === 'SALES'? '660px' : '530px'; 
    const dialogRef = this.dialog.open(EmployeeFormComponent, {
      width: '800px',
      height: clHt,
      panelClass: 'asp-modal-container',
      disableClose:true,
      data:{clicked:true}
    });

    this.subs.dialog = dialogRef.afterClosed().subscribe(result => {

    });
  }

  removeEmployee() {
  }

  getLanguageList() {
    return this.employee.languages ? this.employee.languages?.map(l => this.translate.instant(`common.${l.language}`)).join(', ') : '';
  }

  openLeaveDialog(){
    const holObj = {
      activeYear:new Date().getFullYear().toString(),
      department: this.employee.department,
    }
    this.holidayState.dispatch(new HolidayActions.LoadHolidays(holObj)); 
    const dialogRef = this.dialog.open(AddLeavesComponent, {
      width: 'min(35rem, calc(100vw - 1rem))',
      maxWidth: 'calc(100vw - 1rem)',
      maxHeight: 'calc(100vh - 1rem)',
      panelClass: 'asp-modal-container',
      data: {employee:this.employee,clicked:true},
      disableClose:true
    });
    this.subs.leaveDialog = dialogRef.afterClosed().subscribe(event => {
      if (event && event.action === 'confirm') {

      }
    });
  }

  ngOnDestroy() {
    unsubscribeSubscriptions(this.subs);
  }
}
